const BROKEN_CARL_COX_POSTER = "https://raw.githubusercontent.com/HarryAdamsHLT/HeyLetsTravelFrontend/main/hey-lets-travel-frontend/public/assets/community/photo_2026-07-12_12-41-12.jpg";
const LIVE_CARL_COX_POSTER = "/assets/community/photo_2026-07-12_12-41-12.jpg?v=20260712-1";

function fixCarlCoxPoster() {
  if (typeof document === "undefined") return;

  document.querySelectorAll("img").forEach((img) => {
    if (img.getAttribute("src") === BROKEN_CARL_COX_POSTER || img.src === BROKEN_CARL_COX_POSTER) {
      img.removeAttribute("srcset");
      img.setAttribute("src", LIVE_CARL_COX_POSTER);
    }

    const srcset = img.getAttribute("srcset");
    if (srcset && srcset.includes(BROKEN_CARL_COX_POSTER)) {
      img.setAttribute("srcset", LIVE_CARL_COX_POSTER);
      img.setAttribute("src", LIVE_CARL_COX_POSTER);
    }
  });

  document.querySelectorAll("source").forEach((source) => {
    const srcset = source.getAttribute("srcset");
    if (srcset && srcset.includes(BROKEN_CARL_COX_POSTER)) {
      source.setAttribute("srcset", LIVE_CARL_COX_POSTER);
    }
  });
}

fixCarlCoxPoster();

if (typeof window !== "undefined") {
  window.addEventListener("load", fixCarlCoxPoster, { once: true });
  window.setTimeout(fixCarlCoxPoster, 250);
  window.setTimeout(fixCarlCoxPoster, 1000);

  const observer = new MutationObserver(fixCarlCoxPoster);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["src", "srcset"],
  });
}
